export const isDevelopment = process.env.NODE_ENV === 'development';
export const isProduction = process.env.NODE_ENV === 'production';

export const API_BASE_URL = process.env.REACT_APP_AWS_USER_ENDPOINT;
